import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.254 1.99988H7.25C4.35079 1.99988 2 4.35066 2 7.24988V16.2539C2 19.1511 4.34879 21.4999 7.246 21.4999H16.254C19.1511 21.4999 21.5 19.1512 21.5 16.2549V7.24588C21.5 4.34866 19.1512 1.99988 16.254 1.99988Z",
      class: "bg"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.5 3.75C5.42921 3.75 3.75 5.42921 3.75 7.5V16.504C3.75 18.5728 5.42721 20.25 7.496 20.25H16.504C18.5729 20.25 20.25 18.5727 20.25 16.505V7.496C20.25 5.42721 18.5728 3.75 16.504 3.75H7.5ZM7.5 2.25H16.504C19.4012 2.25 21.75 4.59879 21.75 7.496V16.505C21.75 19.4013 19.4011 21.75 16.504 21.75H7.496C4.59879 21.75 2.25 19.4012 2.25 16.504V7.5C2.25 4.60079 4.60079 2.25 7.5 2.25Z"
    }, null, -1)
  ])))
}
export default { render: render }